module.exports = "<div class=\"tag-types\">\n    <div class=\"tag-types-container\">\n        <dbm-list [listTitle]=\"'Tag Types List'\" [listAction]=\"'Add Tag Type'\" [listItems]=\"tagTypes\"\n            (onActionClick)=\"addTagType()\" (onListItemClick)=\"selectedTagType = $event.selectedItem\"></dbm-list>\n    </div>\n    <tag-type-item [tagTypeItem]=\"selectedTagType\" [hasItems]=\"hasItems || false\"\n        (resetTagType)=\"resetTagType($event)\" (onDelete)=\"deleteTagType($event)\"></tag-type-item>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/tag-types-manager/tag-types-manager.component.html
// module id = 1843
// module chunks = 0